import React, { useEffect, useRef } from "react";
import { SIGNOFF_METHOD_TYPE } from "../../../../../constant/constant";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IconButton } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import Checkbox from "../../../../../library/checkbox/checkbox";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import {
  convertUTCtoLocalTimeZone,
  getDisplayDateSlash,
} from "../../../../../utils/helper";

const SignoffMethod = (props) => {
  const hiddenSignatureInput = useRef(null);
  const hiddenPermitteeSignatureInput = useRef(null);

  useEffect(() => {
    if (
      props?.propsData?.getSwReference?.SwInspectionAcknowledgement &&
      props?.propsData?.certifyStatementIdValue
    ) {
      const findInspectionAcknowledgement =
        props?.propsData?.getSwReference?.SwInspectionAcknowledgement?.find(
          (item) => item.key === props?.propsData?.certifyStatementIdValue
        );
      props?.propsData?.setAcknowledgement(
        findInspectionAcknowledgement?.description ||
          findInspectionAcknowledgement?.value
      );
    }
  }, [
    props?.propsData?.getSwReference,
    props?.propsData?.certifyStatementIdValue,
  ]);

  const showTnSignoff = props?.propsData?.showTnSignoff;

  const rawInspectorSignature =
    props?.propsData?.selectedContractorSignature ||
    props?.propsData?.isSignatureProfile;
  const inspectorSignature =
    rawInspectorSignature && rawInspectorSignature !== "null"
      ? rawInspectorSignature
      : "";

  const hasPermitteeSignature = !!props?.propsData?.selectedPermitteeSignature;
  const storedPermitteeSignedOn =
    props?.propsData?.inspectionDetail?.permitteeSignedOn;
  const permitteeDate = !hasPermitteeSignature
    ? ""
    : storedPermitteeSignedOn
      ? getDisplayDateSlash(
          convertUTCtoLocalTimeZone(storedPermitteeSignedOn, true),
        )
      : getDisplayDateSlash(new Date());

  const renderCertifyStatement = (gridProps = { spacing: 4, my: 1 }) =>
    (parseInt(props?.propsData?.signoffMethodValue) ===
      SIGNOFF_METHOD_TYPE.CERTIFY_STATEMENT ||
      parseInt(props?.propsData?.signoffMethodValue) === 4) &&
    (props?.propsData?.acknowledgement ? (
      <Grid container wrap="wrap" {...gridProps}>
        {props?.propsData?.acknowledgement &&
          props?.propsData?.checkedAcknowledgementError &&
          !props?.propsData?.checkedAcknowledgement && (
            <Grid item xs={12}>
              <Typography className="error acknowledgementError" sx={{ mb: 1 }}>
                Please check acknowledgement
              </Typography>
            </Grid>
          )}
        <Grid item>
          <Checkbox
            checked={props?.propsData?.checkedAcknowledgement}
            onChange={(e) => {
              props?.propsData?.setCheckedAcknowledgement(e.target.checked);
            }}
            label=""
          />
        </Grid>
        <Grid item xs>
          <p className="defaultMsg">{props?.propsData?.acknowledgement}</p>
        </Grid>
      </Grid>
    ) : (
      <></>
    ));

  const renderInspectorSignature = () =>
    (parseInt(props?.propsData?.signoffMethodValue) ===
      SIGNOFF_METHOD_TYPE.SIGNATURE ||
      parseInt(props?.propsData?.signoffMethodValue) === 4) && (
      <>
        {!inspectorSignature && (
          <Grid item md={12} xs={12}>
            <FormLabels label="Add Inspector’s Signature" />

            <input
              type="file"
              ref={hiddenSignatureInput}
              onChange={(event) => {
                props?.propsData?.contractorsignatureUpload(event);
              }}
              style={{ display: "none" }}
              accept="image/*"
            />
            <label
              className="signatureBtn"
              onClick={() => {
                hiddenSignatureInput.current.click();
                props?.propsData?.setImageCheck(true);
              }}
              htmlFor="actual-btn"
            >
              <AddIcon /> Add Signature
            </label>
          </Grid>
        )}

        {props?.propsData?.signaureFileError && (
          <div className="error">
            {props?.propsData?.signaureFileErrorMessage}
          </div>
        )}

        <Grid item lg={12} xs={12} mt={1}>
          {!inspectorSignature && props?.propsData?.signatureError && (
            <p className="error">Please Add Signature</p>
          )}
        </Grid>

        <Grid item container mt={0} className="topHeaderProfile">
          <Grid item lg={6} xs={12} mt={2}>
            <Grid className="signatureImg">
              {inspectorSignature && (
                <>
                  <img
                    className="borderSignatureImg"
                    src={inspectorSignature}
                    alt=""
                  />
                  <div className="overideLables">
                    <div className="formLabel">Authorized signature</div>
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </>
    );

  return (
    <>
      <Grid container>
        {!showTnSignoff && renderCertifyStatement()}
        {!showTnSignoff && renderInspectorSignature()}
      </Grid>

      {showTnSignoff && (
        <Grid container className="tnSignoffSection" mt={3}>
          <Grid item xs={12}>
            <Typography className="tnSignoffHeading">Inspector:</Typography>
          </Grid>

          <Grid item xs={12}>
            {renderCertifyStatement({ columnSpacing: 4, rowSpacing: 0, mt: 1, mb: 2 })}
          </Grid>

          <Grid item xs={12} container spacing={2} mt={0}>
            <Grid item md={6} xs={12}>
              <InputField
                fullWidth={true}
                disabled={true}
                type="text"
                label="Inspector Name"
                isRequired={true}
                value={props?.propsData?.formValue?.primaryInspector ?? ""}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <InputField
                fullWidth={true}
                disabled={true}
                type="text"
                label="Job Title"
                isRequired={true}
                value={props?.propsData?.formValue?.jobTitle ?? ""}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} container mt={1}>
            <FormLabels label="Inspector's Signature" />
          </Grid>
          <Grid item xs={12} container>
            {renderInspectorSignature()}
          </Grid>

          <Grid item xs={12} container spacing={2} mt={0}>
            <Grid item md={6} xs={12}>
              <InputField
                fullWidth={true}
                disabled={true}
                type="text"
                label="Date"
                value={getDisplayDateSlash(props?.propsData?.formValue?.dateofInspection)}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} mt={2}>
            <Typography className="tnSignoffHeading">
              Permittee:
            </Typography>
          </Grid>

          <Grid item xs={12} container spacing={2} mt={0}>
            <Grid item md={6} xs={12}>
              <InputField
                fullWidth={true}
                disabled={true}
                type="text"
                label="Permittee Name"
                value={
                  props?.propsData?.formValue?.projectPrimaryPermitteeName ?? ""
                }
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <InputField
                fullWidth={true}
                disabled={true}
                type="text"
                label="Permittee Job Title"
                value={
                  props?.propsData?.formValue
                    ?.projectPrimaryPermitteeJobTitle ?? ""
                }
              />
            </Grid>
          </Grid>

          <Grid item xs={12} mt={2}>
            <FormLabels label="Permittee Signature" />
            {props?.propsData?.selectedPermitteeSignature ? (
              <div className="signaturePreviewBox removable">
                <img
                  width={"200px"}
                  src={props?.propsData?.selectedPermitteeSignature}
                  alt="Permittee signature"
                />
                {props?.propsData?.canEditPermitteeSignoff && (
                  <IconButton
                    aria-label="Delete permittee signature"
                    className="signatureRemove"
                    onClick={() => props?.propsData?.removePermitteeSignature()}
                  >
                    <DeleteOutlineIcon />
                  </IconButton>
                )}
              </div>
            ) : (
              props?.propsData?.canEditPermitteeSignoff && (
                <>
                  <input
                    type="file"
                    ref={hiddenPermitteeSignatureInput}
                    onChange={(event) =>
                      props?.propsData?.permitteeSignatureUpload(event)
                    }
                    style={{ display: "none" }}
                    accept="image/*"
                  />
                  <label
                    className="signatureBtn"
                    onClick={() => hiddenPermitteeSignatureInput.current.click()}
                  >
                    <AddIcon /> Add Signature
                  </label>
                </>
              )
            )}
            {props?.propsData?.permitteeSignatureFileError && (
              <div className="error">
                {props?.propsData?.permitteeSignatureFileErrorMessage}
              </div>
            )}
          </Grid>
          <Grid item xs={12} container spacing={2} mt={1}>
            <Grid item md={6} xs={12}>
              <InputField
                fullWidth={true}
                disabled={true}
                type="text"
                label="Date"
                value={permitteeDate}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default SignoffMethod;
